/* a2z-pdp-blockgrid.js — 2026-10-09, mobile product-page block grid (branch pdp-blockgrid-2026-10).
   Loaded once per PDP (from snippets/a2z-pdp-price.liquid, and inline in main-product-easton).
   1. Sticky Add to Cart bar shows as soon as the price has scrolled away, and hides while the
      real button is on screen. Each section's own engine still adds .is-on after the button has
      scrolled past; this adds .is-early for the stretch before it, and re-states .is-on after a
      jump the engine's observer misses. Mobile only (<=980px).
   2. The bar's button label follows the buy box state (in / pre / out). Several sections printed
      a fixed "Add to Cart" on load, so a pre-order product offered "Add to Cart" in the bar.
   3. Swipe left / right on the main photo steps through the thumbnails; a "2 / 8" counter shows.
   4. The bar's small line shows the chosen options and the stock word instead of the title.
   5. Care add-ons fold to one row on mobile (round 2, from the Claude Design review). */
(function () {
  if (window.__a2zBlockgrid) return;
  window.__a2zBlockgrid = true;

  function init() {
    var mq = window.matchMedia('(max-width:980px)');
    var bar = document.getElementById('mbar');
    var box = document.querySelector('[data-buybox]');
    var cta = document.querySelector('.buy .cta');
    var price = document.querySelector('.buy .price');

    /* 2. label */
    var btn = document.querySelector('[data-mbar-add]');
    var LABEL = { 'in': 'Add to Cart', 'pre': 'Pre-Order', 'out': 'Out of Stock' };
    function syncLabel() {
      if (!btn || !box) return;
      var want = LABEL[box.getAttribute('data-buybox')];
      if (want && btn.textContent !== want) btn.textContent = want;
    }
    syncLabel();
    if (box && 'MutationObserver' in window) {
      new MutationObserver(syncLabel).observe(box, { attributes: true, attributeFilter: ['data-buybox'] });
    }

    /* 1. early sticky bar. Read from scroll position, not IntersectionObserver: an observer never
       fires when a jump link or "back to top" moves the button from above the screen to below it
       without crossing it, which left the section engine's .is-on stuck on. Mobile only. */
    if (bar && cta && price) {
      var queued = false;
      function syncAria() {
        var shown = bar.classList.contains('is-on') || bar.classList.contains('is-early');
        bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      }
      function update() {
        queued = false;
        if (!mq.matches) { bar.classList.remove('is-early'); return; }
        var p = price.getBoundingClientRect(), c = cta.getBoundingClientRect();
        var ctaPast = c.bottom <= 0, ctaInView = c.bottom > 0 && c.top < window.innerHeight;
        bar.classList.toggle('is-early', p.bottom <= 0 && !ctaInView && !ctaPast);
        bar.classList.toggle('is-on', ctaPast);
        syncAria();
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      /* the section engine also toggles .is-on and writes aria-hidden; keep aria in step with what shows */
      if ('MutationObserver' in window) {
        new MutationObserver(function () { window.requestAnimationFrame(syncAria); })
          .observe(bar, { attributes: true, attributeFilter: ['class'] });
      }
      update();
    }

    /* 4. sticky bar text: the chosen options and the full stock word, in place of the product
       title (which pushed "In stock" off the end as "In ..."). The engines write the stock word
       into [data-stock-short] with querySelectorAll, so that span is kept and moved, never replaced. */
    var small = bar ? bar.querySelector('.mbar__price small') : null;
    var stockSpan = small ? small.querySelector('[data-stock-short]') : null;
    var labels = [].slice.call(document.querySelectorAll('.buy .opt__label em'));
    if (small && stockSpan && labels.length) {
      var optsSpan = document.createElement('span');
      optsSpan.className = 'mbar__opts';
      function syncOpts() {
        var parts = labels.filter(function (em) { return em.offsetParent !== null || em.closest('.opt'); })
          .map(function (em) { return em.textContent.trim(); }).filter(Boolean);
        optsSpan.textContent = parts.join(' · ');
      }
      syncOpts();
      if (optsSpan.textContent) {
        small.textContent = '';
        small.appendChild(optsSpan);
        small.appendChild(document.createTextNode(' · '));
        small.appendChild(stockSpan);
        if ('MutationObserver' in window) {
          var mo = new MutationObserver(syncOpts);
          labels.forEach(function (em) { mo.observe(em, { childList: true, characterData: true, subtree: true }); });
        }
      }
    }

    /* 5. care add-ons fold to one row on mobile ("Protect your sofa · 3 options from $24").
       A ticked row stays visible while folded, so a choice is never hidden. */
    /* Deven 9 Oct: show them expanded and more prominent (framed panel, a2z-pdp.css). The fold is
       kept behind this switch so the folded version is a one-word change. */
    var FOLD_CARE = false;
    [].forEach.call(FOLD_CARE ? document.querySelectorAll('.buy .addons-extra') : [], function (box) {
      var h = box.querySelector('.addons-extra__h');
      var rows = box.querySelectorAll('.addon__row');
      if (!h || rows.length < 2 || !mq.matches) return;
      var min = Infinity;
      [].forEach.call(box.querySelectorAll('.addon__price'), function (pr) {
        var m = (pr.textContent || '').replace(/,/g, '').match(/\$([0-9]+(?:\.[0-9]+)?)/);
        if (m) min = Math.min(min, parseFloat(m[1]));
      });
      var id = 'a2zCare' + Math.random().toString(36).slice(2, 7);
      box.id = box.id || id;
      var btn2 = document.createElement('button');
      btn2.type = 'button';
      btn2.className = 'addons-extra__toggle';
      btn2.setAttribute('aria-expanded', 'false');
      btn2.setAttribute('aria-controls', box.id);
      btn2.innerHTML = '';
      btn2.appendChild(document.createTextNode(h.textContent.trim()));
      var meta = document.createElement('span');
      meta.textContent = rows.length + ' options' + (min < Infinity ? ' from $' + (min % 1 ? min.toFixed(2) : min) : '');
      btn2.appendChild(meta);
      btn2.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
      h.textContent = '';
      h.appendChild(btn2);
      box.classList.add('is-folded');
      btn2.addEventListener('click', function () {
        var open = box.classList.toggle('is-folded') === false;
        btn2.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* 7. chaise side can't be swapped after delivery (Deven, 9 Oct: "scroll to picker first").
       On the 19 pages with a Chaise side picker, the sticky bar's FIRST tap scrolls to that picker
       and highlights it, unless the shopper has already pressed one of its buttons. Any later tap
       adds to cart as normal. Runs in the capture phase so the engine's own add never fires. */
    var chaiseVal = document.getElementById('chaise-val');
    var chaiseOpt = chaiseVal ? chaiseVal.closest('.opt') : null;
    if (chaiseOpt && btn) {
      var sideTouched = false;
      /* isTrusted: the on-load option sync (0. below) presses the side button in code; only a
         shopper's own tap counts as choosing a side */
      chaiseOpt.addEventListener('click', function (e) { if (e.isTrusted && e.target.closest('button')) sideTouched = true; });
      document.addEventListener('click', function (e) {
        if (sideTouched || !e.target.closest || !e.target.closest('[data-mbar-add]')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        sideTouched = true;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        chaiseOpt.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        chaiseOpt.classList.remove('opt--attn');
        void chaiseOpt.offsetWidth;
        chaiseOpt.classList.add('opt--attn');
        var first = chaiseOpt.querySelector('button[aria-pressed="true"]') || chaiseOpt.querySelector('button');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 450);
      }, true);
    }

    /* 6. jump-nav: the markup marks "Overview" active, but on mobile the links are re-ordered
       (Dimensions first). Until the engine's own observer takes over on scroll, mark the first link. */
    var navLinks = [].slice.call(document.querySelectorAll('#secnav a'));
    if (mq.matches && navLinks.length > 1) {
      var first = navLinks.slice().sort(function (a, b) {
        return (parseInt(getComputedStyle(a).order, 10) || 0) - (parseInt(getComputedStyle(b).order, 10) || 0);
      })[0];
      var nav = document.getElementById('secnav');
      if (nav && nav.getBoundingClientRect().top > 0) {
        navLinks.forEach(function (l) { l.classList.toggle('is-active', l === first); });
      }
    }

    /* 3. swipe the main photo */
    var stage = document.getElementById('stage');
    var thumbs = document.getElementById('galThumbs');
    /* photo counter ("2 / 8"), so a phone shopper can tell there is more to swipe */
    var galMain = document.getElementById('galMain');
    var allThumbs = thumbs ? [].slice.call(thumbs.querySelectorAll('.thumb')) : [];
    if (stage && galMain && allThumbs.length > 1) {
      var count = document.createElement('span');
      count.className = 'gal__count';
      count.setAttribute('aria-hidden', 'true');
      (stage.parentNode || stage).appendChild(count);
      var syncCount = function () {
        var sh = (galMain.currentSrc || galMain.src || '').split('?')[0].replace(/^https?:/, '');
        var i = allThumbs.findIndex(function (b) { return (b.getAttribute('data-img') || '').split('?')[0].replace(/^https?:/, '') === sh; });
        if (i < 0) i = allThumbs.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        count.textContent = (Math.max(0, i) + 1) + ' / ' + allThumbs.length;
      };
      syncCount();
      galMain.addEventListener('load', syncCount);
      if ('MutationObserver' in window) new MutationObserver(syncCount).observe(galMain, { attributes: true, attributeFilter: ['src'] });
    }
    if (stage && thumbs) {
      var x0 = null, y0 = 0;
      stage.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var list = [].slice.call(thumbs.querySelectorAll('.thumb')).filter(function (b) { return b.offsetParent !== null; });
        if (list.length < 2) return;
        /* the photo on show decides where we are: some engines swap in the variant's photo
           without moving aria-current (Elvis), so a first swipe would land on the same photo */
        var main = document.getElementById('galMain');
        var shown = main ? (main.currentSrc || main.src || '').split('?')[0].replace(/^https?:/, '') : '';
        var cur = list.findIndex(function (b) { return shown && (b.getAttribute('data-img') || '').split('?')[0].replace(/^https?:/, '') === shown; });
        if (cur < 0) cur = list.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
        if (cur < 0) cur = 0;
        var next = dx < 0 ? cur + 1 : cur - 1;
        if (next < 0 || next >= list.length) return;
        list[next].click();
        if (list[next].scrollIntoView) list[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }, { passive: true });
    }
  }

  /* 0. what you see is what you buy. Since 2026-08-16 the form's variant is the popular IN-STOCK
     one (variant_rank), but most sections still draw the option buttons from Shopify's first
     available variant, so e.g. Signature showed "Left when Sitting" and added Right when Sitting.
     On load, press the option buttons that match the variant the form will add. Runs after the
     section engines have bound their click handlers (DOMContentLoaded + a tick). */
  function syncOptionsToForm() {
    var idInput = document.querySelector('.buy form [name=id]');
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!idInput || !meta || !meta.variants || meta.variants.length < 2) return;
    var want = idInput.value;
    var v = meta.variants.filter(function (x) { return String(x.id) === String(want); })[0];
    if (!v || !v.public_title) return;
    var vals = v.public_title.split(' / ').map(function (s) { return s.trim(); });
    var groups = [].slice.call(document.querySelectorAll('.buy .opt'));
    for (var pass = 0; pass < 2; pass++) {
      groups.forEach(function (g) {
        var btns = [].slice.call(g.querySelectorAll('button[data-value]'));
        var match = btns.filter(function (b) { return vals.indexOf(b.getAttribute('data-value')) > -1; })[0];
        if (match && match.getAttribute('aria-pressed') !== 'true') match.click();
      });
      if (String(idInput.value) === String(want)) break;
    }
    if (String(idInput.value) !== String(want) && window.console) console.warn('[a2z] option sync: form now ' + idInput.value + ', expected ' + want);
  }

  /* the sync runs after DOMContentLoaded (engines bind then) and again on load as a guard; it is
     idempotent, so a second run on an already-matching page presses nothing */
  function later() { setTimeout(syncOptionsToForm, 0); }
  if (document.readyState === 'complete') { init(); later(); }
  else {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('DOMContentLoaded', later);
    window.addEventListener('load', later);
  }
})();
